import type { LendingMode, LenderYields } from '../types'

export function getOrganicYieldOpen(
  amountInUSD: number,
  amountOutUSD: number,
  irModeIn: LendingMode,
  cashFlowDeposits: number,
  cashFlowDebt: number,
  deposits: number,
  debt: number,
  yieldIn: LenderYields,
  yieldOut: LenderYields
): [borrowApr: number, depositApr: number, apr: number] {
  const _flowIn =
    amountInUSD *
    (irModeIn === 1 ? yieldIn.stableBorrowRate : yieldIn.variableBorrowRate)
  const _flowOut = amountOutUSD * yieldOut.depositRate
  const totalCashFlowDebt = cashFlowDebt + _flowIn
  const totalCashFlowDeposits = cashFlowDeposits + _flowOut
  const newCollat = deposits + amountOutUSD
  const newDebt = debt + amountInUSD
  return [
    totalCashFlowDebt / newDebt,
    totalCashFlowDeposits / newCollat,
    (totalCashFlowDeposits - totalCashFlowDebt) / (newCollat - newDebt),
  ]
}

export function getOrganicYieldClose(
  amountInUSD: number,
  amountOutUSD: number,
  irModeOut: LendingMode,
  cashFlowDeposits: number,
  cashFlowDebt: number,
  deposits: number,
  debt: number,
  yieldIn: LenderYields,
  yieldOut: LenderYields
): [borrowApr: number, depositApr: number, apr: number] {
  const _flowIn = amountInUSD * yieldIn.depositRate
  const _flowOut =
    amountOutUSD *
    (irModeOut === 1 ? yieldOut.stableBorrowRate : yieldOut.variableBorrowRate)
  const totalCashFlowDebt = cashFlowDebt - _flowOut
  const totalCashFlowDeposits = cashFlowDeposits - _flowIn
  const newCollat = deposits - amountInUSD
  const newDebt = debt - amountOutUSD
  return [
    Math.abs(newDebt) < 0.01 ? 0 : totalCashFlowDebt / newDebt,
    totalCashFlowDeposits / newCollat,
    (totalCashFlowDeposits - totalCashFlowDebt) / (newCollat - newDebt),
  ]
}

export function getOrganicYieldDebtSwap(
  amountInUSD: number,
  amountOutUSD: number,
  irModeIn: LendingMode,
  irModeOut: LendingMode,
  cashFlowDeposits: number,
  cashFlowDebt: number,
  deposits: number,
  debt: number,
  yieldIn: LenderYields,
  yieldOut: LenderYields
): [borrowApr: number, depositApr: number, apr: number] {
  const _flowIn =
    amountInUSD *
    (irModeIn === 1 ? yieldIn.stableBorrowRate : yieldIn.variableBorrowRate)
  const _flowOut =
    amountOutUSD *
    (irModeOut === 1 ? yieldOut.stableBorrowRate : yieldOut.variableBorrowRate)
  const totalCashFlowDebt = cashFlowDebt + _flowIn - _flowOut
  const newDebt = debt - amountOutUSD + amountInUSD
  return [
    Math.abs(newDebt) < 0.01 ? 0 : totalCashFlowDebt / newDebt,
    cashFlowDeposits / deposits,
    (cashFlowDeposits - totalCashFlowDebt) / (deposits - newDebt),
  ]
}

export function getOrganicYieldCollateralSwap(
  amountInUSD: number,
  amountOutUSD: number,
  cashFlowDeposits: number,
  cashFlowDebt: number,
  deposits: number,
  debt: number,
  yieldIn: LenderYields,
  yieldOut: LenderYields
): [borrowApr: number, depositApr: number, apr: number] {
  const _flowIn = amountInUSD * yieldIn.depositRate
  const _flowOut = amountOutUSD * yieldOut.depositRate
  const totalCashFlowDeposits = cashFlowDeposits + _flowOut - _flowIn
  const newCollat = deposits + amountOutUSD - amountInUSD
  return [
    Math.abs(debt) < 0.01 ? 0 : cashFlowDebt / debt,
    totalCashFlowDeposits / newCollat,
    (totalCashFlowDeposits - cashFlowDebt) / (newCollat - debt),
  ]
}
